export const RED = "#a01c27";
export const RED_LIGHT = "#fde8ea";
export const GREEN = "#43a047";
export const GREEN_LIGHT = "#e8f5e9";
export const BORDER = "#e8e8e8";
// Secondary text. Was #999, which is 2.85:1 on white — under the 4.5:1 needed
// for body text, and this app leans on it for real content (technique blurbs,
// helper lines, timestamps) at 10–13px. #6b6b6b is 5.3:1: clears AA with room
// to spare and still reads as clearly behind the #222 primary text.
// Used as a text colour only — never a background or border.
export const MUTED = "#6b6b6b";
